import styled, { css } from "styled-components";

export const Title = styled.text`
  font-size: 28px;
  font-weight: 500;
`;

export const GroupRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 20px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  ${({ width, marginLeft }: { width?: string, marginLeft?: string }) =>
    css`
      width: ${width ?? "100%"};
      margin-left: ${marginLeft ?? "0px"};
    `}
`;
